var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftType2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.988 5.662c0-.116.02-.228.063-.337a.811.811 0 01.187-.288l4.5-4.5a.72.72 0 01.525-.225c.2 0 .375.076.525.225a.72.72 0 01.225.525.72.72 0 01-.225.525L2.713 5.662l4.075 4.076a.72.72 0 01.225.524.72.72 0 01-.225.525.72.72 0 01-.525.225.72.72 0 01-.525-.225l-4.5-4.5A.813.813 0 011.05 6a.93.93 0 01-.063-.338z",
    fill: "currentColor"
  })));
}
export default SvgArrowLeftType2;